import { ROUTE } from '~/app/routes';

export const USER_ENTRIES = [
  {
    label: 'Personal',
    path: ROUTE.PROFILE,
  },
  {
    label: 'Notifications',
    path: ROUTE.PROFILE_NOTIFICATIONS,
    activePath: ROUTE.PROFILE_NOTIFICATIONS,
  },
];

export const PLATFORM_ENTRIES = [
  {
    label: 'Settings',
    path: ROUTE.PLATFORM_SETTINGS,
    activePath: ROUTE.PLATFORM_SETTINGS,
  },
  {
    label: 'Team',
    path: ROUTE.PLATFORM_TEAM,
    activePath: ROUTE.PLATFORM_TEAM,
  },
  {
    label: 'Roles',
    path: ROUTE.PLATFORM_ROLES,
    activePath: ROUTE.PLATFORM_ROLES,
  },
  {
    label: 'API Keys',
    path: ROUTE.PLATFORM_API_KEYS,
    activePath: `${ROUTE.PLATFORM_API_KEYS}/edit`,
  },
  {
    label: 'Webhooks',
    path: ROUTE.PLATFORM_WEBHOOKS,
    activePath: `${ROUTE.PLATFORM_WEBHOOKS}/edit`,
  },
];

export const TRANSFER_ENTRIES = [
  {
    label: 'Overview',
    path: ROUTE.TRANSFERS,
    activePath: `${ROUTE.TRANSFERS}/edit`,
  },
  {
    label: 'Batches',
    path: ROUTE.TRANSFER_BATCHES,
    activePath: ROUTE.TRANSFER_BATCHES,
  },
  {
    label: 'Pending Approvals',
    path: ROUTE.TRANSFER_APPROVALS,
    activePath: ROUTE.TRANSFER_APPROVALS,
  },
];

export const LOANS_ENTRIES = [
  {
    label: 'Overview',
    path: ROUTE.LOANS,
    activePath: `${ROUTE.LOANS}/edit`,
  },
  {
    label: 'Disbursements',
    path: `${ROUTE.LOANS}/disbursements`,
    activePath: `${ROUTE.LOANS}/disbursements`,
  },
  {
    label: 'Payments',
    path: `${ROUTE.LOANS}/payments`,
    activePath: `${ROUTE.LOANS}/payments`,
  },
];

export const ENTITIES_ENTRIES = [
  {
    label: 'Overview',
    path: ROUTE.ENTITIES,
    activePath: `${ROUTE.ENTITIES}/edit`,
  },
  {
    label: 'Root Entity',
    path: ROUTE.ENTITIES_ROOT_ENTITY,
    activePath: ROUTE.ENTITIES_ROOT_ENTITY,
  },
];

export const DOCUMENT_ENTRIES = [
  {
    label: 'Statements',
    path: ROUTE.STATEMENTS,
    activePath: ROUTE.STATEMENTS,
  },
  {
    label: 'Reports',
    path: ROUTE.REPORTING,
    activePath: ROUTE.REPORTING,
  },
];

export const EVENTS = [
  {
    label: 'Overview',
    path: ROUTE.EVENTS,
  },
  {
    label: 'Webhook',
    path: ROUTE.EVENTS_WEBHOOK,
  },
];

export const CARDS_ENTRIES = [
  {
    label: 'Overview',
    path: ROUTE.CARDS,
    activePath: `${ROUTE.CARDS}/edit`,
  },
  {
    label: 'Programs',
    path: ROUTE.CARD_PROGRAMS,
    activePath: `${ROUTE.CARD_PROGRAMS}/edit`,
  },
  {
    label: 'Accounts',
    path: ROUTE.CARD_ACCOUNTS,
    activePath: `${ROUTE.CARD_ACCOUNTS}/edit`,
  },
  {
    label: 'Tokens',
    path: ROUTE.CARD_TOKENS,
    activePath: `${ROUTE.CARD_TOKENS}/edit`,
  },
  {
    label: 'Transactions',
    path: ROUTE.CARD_TRANSACTIONS,
    activePath: `${ROUTE.CARD_TRANSACTIONS}/edit`,
  },
];
